import { render, staticRenderFns } from "./BuildingSocietyFormDetailsEscalated.vue?vue&type=template&id=5653d3b7&scoped=true&"
import script from "./BuildingSocietyFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyFormDetailsEscalated.vue?vue&type=style&index=0&id=5653d3b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653d3b7",
  null
  
)

export default component.exports